export default "__VITE_ASSET__DTtgZ7Ao__"